import { stripeAll } from './StripeStore';

export const updateStripeAll = (value) => stripeAll.update(oldValue => value);
